import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import GoBack from "components/GoBack";
import Empty from "components/Empty";

import {
  useFindInteractionByPractitionerByIdQuery,
  useFindAllActivityByIdLazyQuery,
  useFindAllPrescriptionsByIdLazyQuery,
} from "generated/graphql";
import userVar from "vars/user";

const PatientDetails = () => {
  const location = useLocation();
  const id = location.state?.id;
  const { data, loading, error } = useFindInteractionByPractitionerByIdQuery({
    variables: {
      interactionId: id,
      practitionerId: userVar().id,
    },
  });

  const [
    findActivities,
    { data: activities, loading: activitiesLoading, error: activitiesError },
  ] = useFindAllActivityByIdLazyQuery();
  const [
    findPrescriptions,
    {
      data: prescriptions,
      loading: prescriptionsLoading,
      error: prescriptionsError,
    },
  ] = useFindAllPrescriptionsByIdLazyQuery();

  useEffect(() => {
    if (data?.findInteractionByPractitionerById) {
      findActivities({
        variables: {
          input: data.findInteractionByPractitionerById.activityId,
        },
      });
    }
  }, [data?.findInteractionByPractitionerById, findActivities]);

  useEffect(() => {
    if (data?.findInteractionByPractitionerById) {
      findPrescriptions({
        variables: {
          input: data.findInteractionByPractitionerById.prescriptionId,
        },
      });
    }
  }, [data?.findInteractionByPractitionerById, findPrescriptions]);

  return (
    <div className="p-4">
      <GoBack />

      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <Empty text={error.message} />
      ) : !data?.findInteractionByPractitionerById ? (
        <Empty text="No Interaction Found" />
      ) : (
        <>
          <section className="my-3">
            <p className="text-sm font-medium mt-4"></p>
            <div className="font-normal ml-3">
              <p>
                {data?.findInteractionByPractitionerById?.practitioner
                  ?.firstName ?? "Unknown"}{" "}
                {data?.findInteractionByPractitionerById?.practitioner
                  ?.lastName ?? "Unknown"}
              </p>
              <p>No-123C</p>
              <div className="flex justify-between">
                <p>954-Ghyui</p>
                <p className="font-medium">7th MAY, 2021</p>
              </div>
            </div>
          </section>

          <hr />

          <section className="my-3">
            <p className="text-sm font-medium mt-4">Patient details</p>
            <div className="font-normal ml-3">
              <p>
                {data?.findInteractionByPractitionerById?.patient?.firstName ??
                  "Unknown"}{" "}
                {data?.findInteractionByPractitionerById?.patient?.lastName ??
                  "Unknown"}
              </p>
              <p>747-klopl</p>
            </div>
          </section>

          <hr />

          <section className="my-3">
            <p className="text-sm font-medium mt-4">Activity</p>
            {activitiesLoading ? (
              <div>Loading...</div>
            ) : activitiesError ? (
              <div>{activitiesError}</div>
            ) : (
              <>
                {Array.isArray(activities?.findAllActivityById) &&
                activities?.findAllActivityById.length > 0
                  ? activities?.findAllActivityById.map((act) => (
                      <div className="font-normal ml-3" key={act.id}>
                        {act.title}
                      </div>
                    ))
                  : "No Activity Found"}
              </>
            )}
          </section>

          <hr />

          <section className="my-3">
            <p className="text-sm font-medium mt-4">Prescriptions</p>
            {prescriptionsLoading ? (
              <div>Loading...</div>
            ) : prescriptionsError ? (
              <div>{prescriptionsError}</div>
            ) : (
              <>
                {Array.isArray(prescriptions?.findAllPrescriptionsById) &&
                prescriptions?.findAllPrescriptionsById.length > 0
                  ? prescriptions?.findAllPrescriptionsById.map((pres) => (
                      <div className="font-normal ml-3" key={pres.id}>
                        {pres.title}
                      </div>
                    ))
                  : "No Prescription Found"}
              </>
            )}
          </section>

          <hr />

          <section className="my-3">
            <p className="text-sm font-medium mt-4">Prescription number</p>
            <div className="font-normal ml-3">
              {data?.findInteractionByPractitionerById?.prescriptionNumber
                ? data?.findInteractionByPractitionerById?.prescriptionNumber
                : "No Prescription Number"}
            </div>
          </section>

          <hr />

          <section className="my-3">
            <p className="text-sm font-medium mt-4">Additional notes</p>
            <div className="font-normal ml-3">
              {data?.findInteractionByPractitionerById?.additionalNotes
                ? data?.findInteractionByPractitionerById?.additionalNotes
                : "No Additional Note"}
            </div>
          </section>
        </>
      )}
    </div>
  );
};

export default PatientDetails;
